import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FileUpload = function FileUpload(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? 'var(--color-primary-light-400)' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M40 16H28V4h2v10h10v2z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M23 44H5V3h24.413L41 14.588V28h-2V15.412L28.587 5H7v37h16v2z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 47a3.405 3.405 0 01-2.413-1L19 31.413V22h9.413L43 36.587c.65.65 1 1.5 1 2.413 0 .9-.362 1.775-1 2.413L38.413 46c-.638.638-1.513 1-2.413 1zM21 30.587l14 14c.525.525 1.475.538 2 0L41.587 40a1.42 1.42 0 000-2l-14-14H21v6.587z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.711 35.703l-1.414-1.415-8 8 1.415 1.414 8-8z",
      fill: secondaryColor
    })]
  });
};
export default FileUpload;